import axios from 'utils/axios';
import { API_PATH } from "config-global";

// ----------------------------------------------------------------------

export const getJackpot = async () => {
  const URL = API_PATH.JACKPOT_GET;
  const response = await axios.post(URL, {});
  return response.data;
}
